<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.operatingInstructions") }}
    </heading>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs"></v-breadcrumbs>
    <operatingInstructionTable />
  </div>
</template>

<script>
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
import operatingInstructionTable from "@/views/operatingInstruction/operatingInstructionTable.vue";
import i18n from "../../i18n";
export default {
  name: "operatingInstruction",
  components: { operatingInstructionTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.operatingInstruction;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.operatingInstruction;
      }
      return sidebarTextDE.default.operatingInstruction;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("operatingInstructions.category.breadcrumbs.name"),
          disabled: false,
          href: `/app/instructionCategory`,
        },
        {
          text: this.title,
          disabled: true,
        },
      ];
    },
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {
    this.title = this.$route.params.instructionCategoryName;
  },
};
</script>
